import { render, staticRenderFns } from "./AssetsSection.vue?vue&type=template&id=45d225bc&"
import script from "./AssetsSection.vue?vue&type=script&lang=js&"
export * from "./AssetsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports